<template>
  <div class="car">
    <sr-list>
      <sr-list-item v-for="(item, index) in DATA" :key="index" :img="item.img" :go="item.href" @click="go">
        <div class="sr-list-txt">
          <p class="p1">{{item.brand}}</p>
          <p class="p2" :title="item.name">{{item.name}}</p>
          <p class="p3">{{item.price | money}}</p>
          <p class="p4">{{item.priceOriginal | money}}</p>
        </div>
      </sr-list-item>
    </sr-list>

    <el-dialog :visible.sync="dialogVisible" width="300px">
      <div class="text-center">
        <p>微信扫一扫</p>
        <p>了解更多精彩信息，在线预约看车</p>
        <sr-qr-code :text="qrCodeText"/>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import srList from '@/components/list'
  import srListItem from '@/components/list/item'
  import SrQrCode from '@/components/QRCode'
  export default {
    components: {
      srList,
      srListItem,
      SrQrCode
    },
    data () {
      return {
        DATA: [{
          img: '//yaolai-img.oss-cn-beijing.aliyuncs.com/group1/M00/00/7F/CgoJFFhJK2aAUvrbAADJFOeyhpU980.jpg',
          brand: 'BENTLEY / 宾利',
          name: '慕尚 2017款 6.75T 黑色 现车',
          price: '6548000',
          priceOriginal: '6548000',
          href: 'https://m2.ylzxvip.com/limousine/#/details/motion?1=1&classify=' + encodeURIComponent('宾利幕尚')
        }, {
          img: '//yaolai-img.oss-cn-beijing.aliyuncs.com/group1/M00/00/80/CgoJFFhJMwOAMGvlAACWW-y3GkU048.jpg',
          brand: 'BENTLEY / 宾利',
          name: '飞驰 V8 4.0T 四座 现车',
          price: '3598000',
          priceOriginal: '3598000',
          href: 'https://m2.ylzxvip.com/limousine/#/details/fly?1=1&classify=' + encodeURIComponent('宾利飞驰')
        }, {
          img: '//yaolai-img.oss-cn-beijing.aliyuncs.com/group1/M00/00/9F/CgoJFFh1m1KAdpbsAAFxbvIhITE384.jpg',
          brand: 'BENTLEY / 宾利',
          name: '添越 2017款SUV 6.0T 现车',
          price: '4798000',
          priceOriginal: '4798000',
          href: 'https://m2.ylzxvip.com/limousine/#/details/bentayga?1=1&classify=' + encodeURIComponent('宾利添越')
        }, {
          img: '//yaolai-img.oss-cn-beijing.aliyuncs.com/group1/M00/00/84/CgoJFFhKKsaAPPMvAACwVdMyFTk969.jpg',
          brand: 'BENTLEY / 宾利',
          name: '欧陆GT V8 2016款 4.0T 四座 现车',
          price: '3108000',
          priceOriginal: '3108000',
          href: 'https://m2.ylzxvip.com/limousine/#/details/GT?1=1&classify=' + encodeURIComponent('宾利欧陆GT')
        }],
        dialogVisible: false,
        qrCodeText: ''
      }
    },
    methods: {
      go (v) {
        this.qrCodeText = v
        this.dialogVisible = true
      }
    }
  }
</script>

<style lang="less" scoped>
  .car {
    width: 1200px;
    margin: 0 auto;
    .sr-list-txt {
      height: 90px;
      line-height: 20px;
      text-align: center;
      p {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .p1, .p4 {
        font-size: 12px;
      }
      .p1 {
        color: #666;
      }
      .p2 {
        color: #333;
        padding-bottom: 10px;
      }
      .p3 {
        color: #cdad66;
      }
      .p4 {
        color: #ccc;
        text-decoration: line-through;
      }
    }
    .text-center {
      text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/car/index.vue